import React, { useRef,useContext,useEffect } from 'react';
import { QRCodeComponent } from '../../components/QRCodeComponent';
import { SharedInfoContext } from '../../components/SharedInfoContextProvider';
import { ShoppingStart } from '../../components/ShoppingStart';
import { iAeonSetData } from '../../library/iaeon_sdk.js';

import styles from '../../styles/Checkout.module.scss';

// import useSound from 'use-sound';
// import se_08 from '../../sound/s08_se_delay0.mp3';

export function RegiSenyouComp(props) {

// const [se08_se] = useSound(se_08);

const ShoppingStartContext = useContext(ShoppingStart);

useEffect(() => {
	document.body.classList.add('bg_white');
	document.getElementById('header').classList.remove('is_fixed');
	document.getElementById('header').classList.remove('is_behind');

	props.setRegiType("regi_senyou_comp");

	// console.log("REACT_APP_IAEON_FLG: " + process.env.REACT_APP_IAEON_FLG);
	// if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
	// 	console.log("iAEON 有効");
	// 	//データ保存API（削除
	// 	callAPI_18_delete();
	// }else{ //iAEON無効
	// }

	//高さ調整：arrows We 対応
	if(window.innerWidth >= 320){
		document.documentElement.style.zoom = window.innerWidth / 390;
		var zratio = window.innerWidth / 390;
	}else{
		document.documentElement.style.zoom = 1;
		var zratio = 1;
	}
	let hratio = window.innerHeight / (window.innerHeight * zratio);
	let realheight = window.innerHeight * hratio;
	let elementA = document.getElementById('regiFrame');
	if (elementA) {
		elementA.style.height = realheight + 'px';
	}
}, []);

// const ShowModal = () => {
// 	props.setShowModal(true)
// 	// setOpen(true)
// }
const goKujiLottery = () => {
	props.setPage("kuji_lottery");
	// se08_se();
	props.setSoundState("se08_se");
}
const goKujiList = () => {
	props.setPage("kuji_list");
	// se08_se();
	props.setSoundState("se08_se");
}
const goRegiMeisai = () => {
	props.setPage("regi_meisai");
	// se08_se();
	props.setSoundState("se08_se");
}

//18.データ保存API（削除
function callAPI_18_delete(){
	console.log("----------------------------");
	console.log("【iAeonSetData】post");
    let successCall_18 = function(success){
        // var aaa = JSON.stringify(success);
        // console.log('successCall：' + aaa);
		var aaa = success;
		console.log('【iAeonSetData】success：');
		console.log(aaa);
    }
    let errorCall_18 = function(error){
        // var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonSetData】error: ' + error.error_code + " : " + error.message);
		console.log(bbb);
    }
    // window.iAeonMiniApp.iAeonSetData({"mode":"add", "key": "shopping_data", "value": shoppingJSON}).then(successCall_18).catch(errorCall_18);
    // window.iAeonMiniApp.iAeonSetData({"mode":"put", "key": "shopping_data", "value": shoppingJSON}).then(successCall_18).catch(errorCall_18);
	iAeonSetData({"mode":"delete", "key": "shopping_data"}).then(successCall_18).catch(errorCall_18);
	// window.iAeonMiniApp.iAeonSetData({"mode":"delete", "key": "shopping_data"}).then(successCall_18).catch(errorCall_18);
}

const sharedInfo = useContext(SharedInfoContext);

return (
	<>
	<div id="regiFrame" className={styles.regiFrame}>
	<div id="checkoutBox" className={styles.checkoutBox}>

{
	(() => {
		if(ShoppingStartContext.data){
			if (ShoppingStartContext.data.bonusFlag === 1) { //ボーナス有効
				if(props.shoppingData){
					if (props.shoppingData.data) { //SUCCESS

						if(props.shoppingData.data.campaign.bonusAmount === 0){ //売上なし
							return (
								<></>
							)
						}else{ //通常表示
							return (
								<div className={styles.bonus_result}>
									<p className={styles.bonus_result_txt}>
										<span>{props.shoppingData.data.campaign.bonusAmount ? (props.shoppingData.data.campaign.bonusAmount).toLocaleString('ja-JP') : 0}</span>円引きが適用されました
									</p>
									<span className={styles.bonus_result_img}>
										<img src="/images/kuji/bonus_result.png" alt="" width="390" height="72"/>
									</span>
								</div>
							)
						}

					}else{ //売上なし
						return (
							<></>
						)
					}
				}else{ //売上なし
					return (
						<></>
					)
				}
			}
		}
	})()
}

		<p className={styles.checkoutBox_tit}>お買い上げ<br/>ありがとうございました</p>
		<p className={styles.checkoutBox_txt}>お支払い後はこちらのコードを<br/>ゲートにかざしてください</p>
{
	(() => {
		if (sharedInfo.exitGateQR === null) { //QR異常 ゲートQRエラー画面
		return(
			<div className={styles.checkoutBox_qrfail}>
				<div className={styles.checkoutBox_qrfail_alertImg}>
					<img src="/images/icn_caution.svg" alt="" width="48" height="48" />
				</div>
				<p className={styles.checkoutBox_qrfail_tit}>コードの生成に失敗しました</p>
				<p className={styles.checkoutBox_qrfail_txt}>恐れ入りますが、お近くの<br/>従業員までお申し出ください</p>
			</div>
		)
		} else { //QR通常 ゲートQR生成
		return (
			// <div className={styles.checkoutBox_qrfail}>
			// 	<div className={styles.checkoutBox_qrfail_alertImg}>
			// 		<img src="/images/icn_caution.svg" alt="" width="48" height="48" />
			// 	</div>
			// 	<p className={styles.checkoutBox_qrfail_tit}>コードの生成に失敗しました</p>
			// 	<p className={styles.checkoutBox_qrfail_txt}>恐れ入りますが、お近くの<br/>従業員までお申し出ください。</p>
			// </div>
			<div className={styles.checkoutBox_img}>
				<QRCodeComponent value={sharedInfo.exitGateQR} size={202} bgColor="#FFFFFF" fgColor="#000000" />
			</div>
		)
		}
	})()
}

		<button className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></button>

		{
			(() => {
				if(ShoppingStartContext.data.lotteryFlag === 1){ //くじ有効
					if(props.shoppingData){
						if (props.shoppingData.data) { //SUCCESS
							if(props.shoppingData.data.campaign.lotteryTimes !== 0){ //くじ回数0でない
								if (props.kujiResult.length === 0) { //くじを引く
									return(
										<button className={styles.kujiBtn} onClick={goKujiLottery}><span className={styles.kujiBtn_in}><span>
										<span className={styles.kujiBtn_in_icn}>
											<img src="/images/icn_kujibtn.svg" alt="" width="29" height="39" />
										</span>
										くじを引く</span></span></button>
									)
								} else { //くじの結果を見る
									return (
										<button className={styles.kujiBtn} onClick={goKujiList}><span className={styles.kujiBtn_in}><span className={styles.is_noicn}>くじの結果を見る</span></span></button>
									)
								}
							}

						}
					}
				}
			})()
		}
	</div>
	</div>
	</>
)

}
